import type { WegicRequestConfig } from '@wegic/request';
import type { ShortcutSuggestionDetail } from './type';
import { agentsRequest } from '@/services/request';

/**
 * 获取快捷指令详情
 */
export async function getShortcutSuggestionDetail(
  id: string,
  config?: WegicRequestConfig,
) {
  return agentsRequest.get<ShortcutSuggestionDetail>(
    `/projects/shortcuts/v1/${id}`,
    config,
  );
}
